<template>
  <div>
    <BBSelectNew :options="input.options"
               :label="input.listLabel"
               :placeholder="input.placeholder"
               :searchable="input.searchable"
               :searchableBy="input.searchableBy"
               :searchableGet="input.searchableGet"
               :disabled="input.disabled"
               :error="errorText"
               :value="value"
               @change="setValue"
               @scrollEnd="scrollEnd"/>
  </div>
</template>

<script>
import BBSelectNew from '@/components/Main/Inputs/BBSelectNew'
import {get, set} from 'lodash'

export default {
  name: 'BBSelectInput',
  props: ['input', 'model', 'errorText'],
  components: {BBSelectNew},
  computed: {
    value () {
      const value = get(this.model, this.input.model, '')
      const firstItem = get(this.input, ['options', 0], '')
      return this.input.clearable ? value || '' : value || firstItem
    }
  },
  methods: {
    setValue (val) {
      set(this.model, this.input.model, val)
      this.$emit('input', val, this.input)
    },
    scrollEnd () {
      this.$emit('scrollEnd')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

</style>



// WEBPACK FOOTER //
// src/components/Main/Form/BBSelectInput/BBSelectInput.vue